import { Node } from '@atlaskit/editor-prosemirror/model';
export class ProseMirrorContentStatistics {
  constructor(content) {
    this.content = content;
  }

  /**
   * Calculate statistics for the ProseMirror content such as node counts, mark counts and total character count.
   */
  collectStatistics() {
    const {
      nodeCounts,
      markCounts
    } = this.countNodesAndMarks();
    const {
      totalCharacterCount
    } = this.calculateCharacterCounts();
    return {
      nodeCounts,
      markCounts,
      totalCharacterCount,
      contextSelectionScope: undefined
    };
  }
  countNodesAndMarks() {
    let nodeCounts = new Map();
    let markCounts = new Map();
    this.content.descendants(node => {
      nodeCounts.set(node.type.name, (nodeCounts.get(node.type.name) || 0) + 1);
      node.marks.forEach(mark => {
        markCounts.set(mark.type.name, (markCounts.get(mark.type.name) || 0) + 1);
      });
    });
    return {
      nodeCounts: Object.fromEntries(nodeCounts),
      markCounts: Object.fromEntries(markCounts)
    };
  }
  calculateCharacterCounts() {
    let allTextContent = '';
    if (this.content instanceof Node) {
      allTextContent = this.content.textContent;
    } else {
      this.content.forEach(child => {
        allTextContent += child.textContent;
      });
    }
    return {
      totalCharacterCount: allTextContent.length
    };
  }
}